<template>
    <div class="products">
        <div class="product-filter md-layout">
            <md-field class="md-layout-item">
                <label for="categories">{{ $tc('categories.category',2) }}</label>
                <md-select v-model="filter"
                    name="categories"
                    id="categories"
                    @input="fetchProducts('init')">
                    <md-option value="undefined">
                        {{ $t('general.all') }}
                    </md-option>
                    <md-option v-for="category in categories"
                        :key="category.category_id"
                        :value="category.category_id">
                        {{ category.category_name }}
                    </md-option>
                </md-select>
            </md-field>
            <md-field md-clearable
                class="md-layout-item">
                <md-input :placeholder="$t('general.search-by-name')"
                    v-model="search"
                    @input="debouncedFetch('init')"
                    ref="productNameInput">
                </md-input>
            </md-field>
        </div>
        <div class="row">
            <div v-for="(product, index) in products"
                :key="index"
                class="product-item">
                <!-- CARDS -->
                <Card :product="product"
                    :units="units"
                    :product-status="productStatus">
                </Card>
            </div>
            <div v-if="noProducts.length === 0"
                class="no-product-items">
                {{ $t('$vuetify.noDataText') }}
            </div>
        </div>
        <div v-if="this.notLastPage"
            class="no-product-items">
            {{ $t('products.scroll') }}
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import productsService from '@/components/products/services/'
import productsStatusService from '@/components/products/services/productsStatus.js'
import unitsService from '@/components/units/services/'
import categoriesService from '@/components/categories/services/'
import Card from '@/components/orders/products/Item'

export default {
    name: 'ProductsListCards',

    components: {
        Card
    },

    data () {
        return {
            selectedTab: '1',

            search: '',

            filter: undefined,

            categories: [],

            units: [],

            productStatus: [],

            products: [],

            notLastPage: false,

            paginationAux: {
                page: 1,
                rowsPerPage: 15,
                totalItems: 0
            }
        }
    },

    methods: {
        async fetchProductStatus () {
            let self = this

            let params = {}

            let response = await productsStatusService.getProductsStatus(params)
            self.productStatus = _.cloneDeep(response.data.results)
        },

        async fetchCategories () {
            let self = this

            let params = {}

            let response = await categoriesService.getAll(params)
            _.forEach(response.data.results, category => {
                category.id = String(category.category_id)
            })

            self.categories = _.cloneDeep(response.data.results)
        },

        async fetchUnits () {
            let self = this

            let params = {
                filter: {
                    active: 1
                }
            }

            let response = await unitsService.retrieve(params)
            self.units = _.cloneDeep(response.data.results)
        },

        async fetchProducts (action) {
            let self = this

            if (action === 'init') {
                self.products = []
                self.paginationAux.page = 1
                self.paginationAux.rowsPerPage = 15
                self.notLastPage = false
            } else {
                self.paginationAux.page = self.paginationAux.page + 1
            }

            let parameters = {
                pagination: {
                    page: self.paginationAux.page,
                    rowsPerPage: self.paginationAux.rowsPerPage
                },
                filter: {
                    category_id: self.filter === 'undefined' ? _.reduce(
                        self.categories,
                        function (result, value, key) {
                            result.push(value.category_id)
                            return result
                        },
                        []
                    ) : self.filter,
                    product_name: self.search,
                    active: 1
                },
                orderBy: {
                    column: 'product_name',
                    direction: 'ASC'
                }
            }

            let response = await productsService.retrieve(parameters)
            if (action === 'init') {
                self.products = _.cloneDeep(response.data.results)
            } else {
                self.products = self.products.concat(response.data.results)
            }

            self.paginationAux.totalItems = response.data.pagination.totalItems
            self.paginationAux.rowsPerPage = response.data.pagination.rowsPerPage
            self.paginationAux.page = response.data.pagination.currentPage
        },

        async scroll () {
            let self = this

            let bottomOfWindow = document.documentElement.scrollTop + document.documentElement.offsetHeight >= document.documentElement.scrollHeight * 0.8
            self.notLastPage = self.paginationAux.page < Math.ceil(self.paginationAux.totalItems / self.paginationAux.rowsPerPage)
            if (bottomOfWindow && self.notLastPage) {
                await self.fetchProducts('add')
            }
        }
    },

    created () {
        let metadatas = [
            this.fetchProducts('init'),
            this.fetchUnits(),
            this.fetchCategories(),
            this.fetchProductStatus()
        ]
        Promise.all(metadatas)

        window.addEventListener('scroll', this.scroll)
    },

    destroyed () {
        window.removeEventListener('scroll', this.scroll)
    },

    computed: {
        noProducts () {
            return this.products
        },

        debouncedFetch (action) {
            return _.debounce(function (action) {
                this.fetchProducts(action)
            }, 400)
        }
    }
}
</script>
